import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const HandTagIcon = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <path
      clipRule="evenodd"
      d="M11.3673 4.50658C10.1758 3.69137 8.57274 3.84037 7.55193 4.86118L5.17563 7.23748C4.15482 8.25829 4.00583 9.8614 4.82103 11.0528L10.778 19.7592C11.1316 20.276 11.8677 20.3444 12.3104 19.9017L20.2161 11.996C20.6589 11.5532 20.5904 10.8171 20.0737 10.4636L11.3673 4.50658ZM6.13771 3.44697C7.83907 1.74561 10.5109 1.49729 12.4967 2.85596L21.2031 8.81296C22.7533 9.87367 22.9586 12.082 21.6303 13.4102L13.7247 21.3159C12.3964 22.6441 10.1881 22.4389 9.12741 20.8886L3.17042 12.1822C1.81174 10.1965 2.06007 7.52461 3.76142 5.82326L6.13771 3.44697ZM9.15877 7.42472C9.56928 7.79418 9.60255 8.42647 9.23309 8.83698L9.22309 8.84809C8.85363 9.25859 8.22134 9.29187 7.81083 8.92241C7.40032 8.55295 7.36705 7.92066 7.73651 7.51015L7.74651 7.49904C8.11597 7.08853 8.74826 7.05526 9.15877 7.42472Z"
      fill={EColor.Black}
      fillRule="evenodd"
    />
  ),
});
